<template>
    <div class="content">
        <h1>ALLGEMEINE GESCHÄFTSBEDINGUNGEN</h1>
        <h2>§ 1 &nbsp;|&nbsp; Geltungsbereich</h2>
        <p>
            Nachfolgende Bestimmungen gelten ausschließlich für den gesamten Geschäftsverkehr mit dem Gewerbe 'aixtrologics &nbsp;|&nbsp; kosmologische dienstleistungen' - Inh. Guido Buchholz, Oststraße 15, 52222 Stolberg, im Folgenden 'aixtrologics' genannt, sofern nicht andere Bedingungen schriftlich ausdrücklich anerkannt sind.
        </p>
        <h2>§ 2 &nbsp;|&nbsp; Angebote</h2>
        <p>
            (1) Alle im SHOP angebotenen Produkte werden ausschließlich in digitaler Form angeboten und per E-Mail-Anhang versandt.<br>
            (2) Text-Analysen werden im PDF-Format, Grafiken im JPG-Format versendet.
        </p>
        <h2>§ 3 &nbsp;|&nbsp; Vertragsschluss</h2>
        <p>
            (1) Der Vertrag kommt dadurch zustande, dass der Kunde im SHOP ein Produkt bestellt und von aixtrologics innerhalb eines Werktages eine Bestätigung seiner Bestellung per E-Mail erhält. Dieser E-Mail hängt die Rechnung als PDF-Datei an.<br>
            (2) Mit Vertragsabschluss treten die Paragraphen 4-7 der AGB in Kraft.
        </p>
        <h2>§ 4 &nbsp;|&nbsp; Widerrufsrecht und Umtausch</h2>
        <p>
            (1) Der Käufer hat das Recht, innerhalb von 14 Tagen ab Online-Bestellung ohne Angabe von Gründen vom Kauf zurück zu treten (z.B. per E-Mail-Mitteilung), solange er das bestellte Produkt noch nicht erhalten hat.<br>
            (2) Aufgrund der digitalen Form der im SHOP angebotenen Produkte erlischt das Widerrufsrecht nach Erhalt des Produktes.<br>
            (3) Ebenso ist ein Umtausch des erhaltenen Produktes nach Warenerhalt nicht möglich.
        </p>
        <h2>§ 5 &nbsp;|&nbsp; Mängelansprüche, Reklamationen</h2>
        <p>
            (1) Ist aixtrologics nachweislich ein Fehler bezüglich der das vertriebene Produkt betreffenden Geburtsdaten unterlaufen, verpflichtet sich aixtrologics, das selbe Produkt nochmals kostenfrei und mit korrigierten Daten an den Käufer zu senden.<br>
            (2) Ebenso verpflichtet sich aixtrologics, das selbe Produkt nochmals kostenfrei an den Käufer zu senden, falls die versendete Datei beschädigt und nicht verwendbar ist.
        </p>
        <h2>§ 6 &nbsp;|&nbsp; Fälligkeit und Zahlung</h2>
        <p>
            Der Käufer verpflichtet sich, die Zahlung des bestellten Produktes ohne Abzug per Vorkasse und Überweisung innerhalb von 14 Tagen nach Rechnungserhalt an das in der Rechnung angegebene Konto zu leisten.
        </p>
        <h2>§ 7 &nbsp;|&nbsp; Lieferung</h2>
        <p>
            (1) Die Lieferung erfolgt - sofern auf der Webseite nicht ausdrücklich anders angegeben - umgehend nach Zahlungseingang, spätestens jedoch nach Ablauf von 3 Werktagen nach Zahlungseingang.<br>
            (2) Im Falle von Betriebsferien wird auf der Webseite ausdrücklich auf die dadurch verlängerte Lieferzeit hingewiesen.
        </p>
        <h2>§ 8 &nbsp;|&nbsp; Nichtverfügbarkeit</h2>
        <p>
            (1) aixtrologics kann die jederzeitige Verfügbarkeit der Website und des SHOPS nicht garantieren.<br>
            (2) Aus technischen Gründen, insbesondere während Wartungsarbeiten, kann die Verfügbarkeit der aixtrologics-Website zeitweise eingeschränkt sein.
        </p>
        <h2>§ 9 &nbsp;|&nbsp; Datenschutz</h2>
        <p>
            (1) Die im SHOP eingegebenen Kundendaten werden in Form von Anrede, Name, Adresse, E-Mail-Adresse und Telefonnummer gespeichert.<br>
            (2) Die Speicherung und Verarbeitung der Kundendaten erfolgt unter Beachtung des Bundesdatenschutzgesetzes und der DSGVO.<br>
            (3) Es gilt unsere <router-link to="/datenschutz">Datenschutzerklärung</router-link>.
        </p>
        <h2>§ 10 &nbsp;|&nbsp; Schlussbestimmungen</h2>
        <p>
            Reklamationen/Widerrufe richten Sie bite an die im Impressum hinterlegte Firmenadresse oder per E-Mail an <a href="mailto:info@aixtrologics.com">info@aixtrologics.com</a>.
        </p>
        <p>
            Stand: Aktuell gültige Version von {{ currentMonth }} {{ currentYear }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'agb',
    data() {
        return {
            currentMonth: '',
            currentYear: ''
        };
    },
    methods: {
        getCurrentMonth() {
            const monthNames = [
                'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
            ];

            const d = new Date();
            this.currentMonth = monthNames[d.getMonth()];
            this.currentYear = d.getFullYear();
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    created() {
        this.getCurrentMonth();
    },
    mounted() {
        this.emitLogData('agb', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('agb', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    h2 {
        margin-top: 30px;
    }
</style>
